export const ActionButtonEnum = Object.freeze({
  ADD: 'add',
  REMOVE: 'remove',
});
